<template>
    <div v-if="isShowGoHome" class="toHome" @click="toHome"></div>
</template>
<script>
export default {
    name: 'GoHome',
    data() {
        return {
            isShowGoHome: true,
        }
    },
    async created() {
        if(this.$route.name === 'News' || this.$route.name === 'Search'){
            let isMiniprogram = await this.$Common.Attribute.isMiniprogram()
            this.isShowGoHome =  isMiniprogram ? false : true;
        }else{
            this.isShowGoHome = true;
        }
    },
    methods: {
        toHome() {
            this.$router.push('/')
        },
    },
    watch: {
        async $route (val, oldVal) {
            if(val.name === 'News' || val.name === 'Search'){
                let isMiniprogram = await this.$Common.Attribute.isMiniprogram()
                this.isShowGoHome =  isMiniprogram ? false : true;
            }else{
                this.isShowGoHome = true;
            }
        },
        
    },

}
</script>
<style lang="less" scoped>
.toHome {
    width: 17.867vw;
    height: 17.867vw;
    background: url('./../assets/img/toHome.png') center no-repeat;
    background-size: cover;
    position: fixed;
    bottom: 30.667vw;
    right: 2.133vw;
}
</style>